import { kebabize, consoleString } from './utils';

async function loadScript({type, isUtil = false, isTypeScript = false}) {

  if (!isUtil) {
    console.time(`✅ ${type} library script loaded in`);
    await import(`./${kebabize(type)}${isTypeScript ? "/index.ts" : ""}`)
      .then((src) => {
        console.timeEnd(`✅ ${type} library script loaded in`);
        src.default.init();
      })
      .catch((err) => {
        console.log(
          `%c❌ an error occurred while loading the ${type} library\n`,
          consoleString.error,
          err
        );
      });
  } else {
    console.timeEnd(`✅ ${type} utility script loaded in`);
    await import(`./utils`)
      .then((src) => {
        console.timeEnd(`✅ ${type} utility script loaded in`);
        src[type].init();
      })
      .catch((err) => {
        console.log(
          `%c❌ an error occurred while loading the ${type} library\n`,
          consoleString.error,
          err
        );
      });
  }
}

const loader = {
  loadScript
}

export default loader;
